import { ContactType } from '../../type/contact';
import { networkService } from '../network/axios-instance';

export async function getPage(page: string) {
  return networkService.get(`v1/pages/${page}`);
}

export async function sendContact(params: ContactType) {
  return networkService.post(`v1/contact`, params)
}